import type { ImageLoaderProps } from 'next/image';

import { replaceS3ToCloudFront } from '../common/image-optimization/replaceS3ToCloudFront';

/**
 * UImage 컴포넌트 관련 이미지 최적화 로직을 담당하는 서비스
 */
export class UImageService {
  /**
   * Next.js Image loader 생성
   *
   * URL 생성에는 loaderProps.width만 사용합니다.
   * 표시 비율이 정사각형인 경우(isSquare) 요청 크기에 맞춰 h 파라미터를 함께 전달합니다.
   *
   * @link https://github.com/vercel/next.js/discussions/22050
   */
  static defaultLoader({
    isSquare,
  }: {
    isSquare: boolean;
  }): (loaderProps: ImageLoaderProps) => string {
    return (loaderProps: ImageLoaderProps): string => {
      try {
        const requestedWidth = loaderProps.width;

        const optimizedUrl = replaceS3ToCloudFront({
          url: loaderProps.src,
          w: requestedWidth,
          ...(isSquare && { h: requestedWidth }),
        });

        return optimizedUrl || loaderProps.src;
      } catch {
        return loaderProps.src;
      }
    };
  }

  /**
   * loaderProps에서 width를 받아 최적화된 URL을 생성하는 Next.js Image loader
   *
   * h 파라미터를 전달하지 않아, Next.js loader 제한과 무관하게 동작합니다.
   */
  static widthOnlyLoader(loaderProps: ImageLoaderProps): string {
    try {
      const numWidth = loaderProps.width;

      const optimizedUrl = replaceS3ToCloudFront({
        url: loaderProps.src,
        w: numWidth,
      });

      return optimizedUrl || loaderProps.src;
    } catch {
      return loaderProps.src;
    }
  }
}
